export default __webpack_public_path__ + "static/media/portfolio4.20722696.jpg";